import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	associateGoalsFieldBody: {
		id: 'business-fields.goals.cell.associate-field-popup.associate-goals-field-body',
		defaultMessage:
			"The <bold>{fieldName}</bold> field isn't associated with the <bold>{issueType}</bold> issue type.",
		description:
			'The description for the popup  to inform the user to associate the goals field to the issue type to use it',
	},
	contactAdmin: {
		id: 'business-fields.goals.cell.associate-field-popup.contact-admin',
		defaultMessage: 'Contact Admin',
		description:
			'The button text to contact the admin to associate the goals field to the issue type to use it',
	},
	updateFieldAssociationAction: {
		id: 'business-fields.goals.cell.associate-field-popup.update-field-association-action',
		defaultMessage: 'Update field association',
		description: 'The button text to associate the goals field to the issue type to use it',
	},
});
